// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wcqTv","controls":"styles_controls__6c75i","charLimit":"styles_charLimit__3grk5","input":"styles_input__1-ZIB","send":"styles_send__2A7uW"};